export const environment = {
  production: false,
  version: '2.2',
  apiRoot: 'http://localhost:8080',
  // apiRoot: '.',
};
